import generateUtilityClasses from '@mui/material/generateUtilityClasses';

export const selectOptionClasses = generateUtilityClasses('AFSelectOption', [
  'root',
  'disabled',
  'nested',
  'selected',
  'focused',
  'lastSelected',
  'group',
  'groupName',
  'icon',
  'text',
  'groupText',
  'multiline',
  'secondaryText',
  'badgeWrapper'
]);
